import { useNavigate } from "react-router-dom";
import TextRenderer from "src/app/components/commonComponents/TextRenderer";
import { AppRoutes } from "src/app/navigation/routes";
import { EyengagePost } from "src/shared/types/src";

export default function PostDescriptionComponent({ descriptionText, postData, showFullText }: { descriptionText: string, postData: EyengagePost, showFullText?: boolean }) {
    const navigate = useNavigate();

    const handlePostDetailsRedirect = () => {
        navigate(`${AppRoutes.EYENGAGE_POST_DETAILS}/${postData.id}`);
    }

    return (

        <div className='fs-12 text-black mg-t-15'>
            {showFullText ?
            <TextRenderer text={descriptionText} />
            // <>{descriptionText}</>
            :
            <div onClick={handlePostDetailsRedirect} className="cursor-pointer">
                {/* handle read more, read less functionality. */}
                <TextRenderer text={descriptionText} />
            </div>}
        </div>
    )
}